import {getIn} from '@uiux/fn';

export function getUpdatedAtSeconds(data: any) {
  return getIn(data, 'updatedAt.seconds', null);
}
